import { MetricData } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import CoreTrendCell from "pro-features/components/core cells/src/CoreTrendCell/CoreTrendCell";

import type { MarketSizeDataPoint } from "../types";

import { Loader } from "./Loader";

const TrendCellConfig = {
    chart: { height: 100 },
};
interface IUniqueVisitors {
    uniqueData: MarketSizeDataPoint[];
    absoluteUniqueValue: string;
    showGraph: boolean;
    isLoading: boolean;
    title: string;
}

export const UniqueVisitors = ({
    uniqueData,
    absoluteUniqueValue,
    showGraph = false,
    isLoading = true,
    title,
}: IUniqueVisitors) => {
    const metricNameProps = {
        displayName: translate(title),
    };

    const valueProps = {
        displayValue: absoluteUniqueValue,
    };

    if (isLoading) {
        return <Loader />;
    }

    const trendCellData = uniqueData && [{ data: uniqueData.map((item) => item.Value) }];

    return (
        <Flex
            width="100%"
            height="100%"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            padding="50px 22px 17px 22px"
            data-automation="audience-unique-visitors"
        >
            <MetricData
                metricNameProps={metricNameProps}
                valueProps={valueProps}
            />
            {showGraph ? (
                <Flex
                    width="100%"
                    data-automation="unique-visitors-trends-line-container"
                >
                    <CoreTrendCell
                        data={trendCellData}
                        config={TrendCellConfig}
                    />
                </Flex>
            ) : null}
        </Flex>
    );
};
